module.exports = __webpack_public_path__ + "media/apple-quiz-ce43117b.svg";